<template>
  <div style=" display: flex; align-items: center; justify-content: flex-end" :style="{height: `${height}px`}">
    <el-button
      size="small"
      style="width: 30px; height: 30px"
      @click="change('prev')"
      :disabled="page <= 1"
      :title="t('prev_page')"
      :aria-label="t('prev_page')"
    >
      <i class="iconfont icon-icon_arrowsleft" style="font-size: 16px; line-height: 16px"/>
    </el-button>
   <span style="margin: 0 20px; color: #409eff" v-if="isShowPage">{{ `${page}/${total}`}}</span>
    <el-button
      size="small"
      style="width: 30px; height: 30px"
      @click="change('next')"
      :disabled="!hasMore"
      :title="t('next_page')"
      :aria-label="t('next_page')"
    >
      <i class="iconfont icon-icon_arrowsrigh" style="font-size: 16px; line-height: 16px"/>
    </el-button>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

let call = defineEmits(["changePage"])
let type = ref("next")

const props = defineProps({
  page: {
    type: Number,  // 0 修改昵称 1 设置新密码
    default: 1
  },
  total: {
    type: Number,  // 0 修改昵称 1 设置新密码
    default: 0
  },
  hasMore:{
    type: Boolean,
    default: true
  },
  height: {
    type: Number,  // 
    default: 60
  },
  isShowPage: {
    type: Boolean,
    default: false
  }
})

function change(str: string) {
  type.value = str
  call("changePage", str)
}

</script>
